module.exports = __webpack_public_path__ + "static/media/user8.a1a3fccb.gif";